import {AuthLevel, IPermissions, IUserGroupPermissions} from '..';
import {LogCat, LogManager} from "../../../common/log";

export class UserPermissions {

	constructor(private permissionsData: IPermissions,
				private applySecurityByActiveRole:boolean) {
	}

	public highestPermission(permission: string, group: number): AuthLevel {
		// If the permission does not exist.
		if (!this.permissionsData.hasOwnProperty(permission)) {
			LogManager.warn(LogCat.UI.Permissions, "Missing permission for " + permission + ". Full permission is granted.");
			return AuthLevel.Full;
		}

		let userPer = this.getUserPermission(permission);
		if ((userPer !== null) && (userPer !== undefined)){
			return userPer;
		}

		let groupPer = this.getGroupsPermission(permission);
		if (groupPer) {
			if (this.applySecurityByActiveRole) {
				return groupPer[group]!==undefined? groupPer[group] : AuthLevel.Hidden;
			} else {
				let authLevel: AuthLevel = AuthLevel.Hidden;
				Object.keys(groupPer).forEach(currGroup => {
					authLevel = groupPer[currGroup] < authLevel ? groupPer[currGroup] : authLevel;
				});
				return authLevel;
			}
		}

		return AuthLevel.Hidden;
	}

	public getPermission(permission: string): IUserGroupPermissions {
		return this.permissionsData[permission];
	}

	public getUserPermission(permission: string): AuthLevel {
		let per = this.getPermission(permission);
		return per ? per.user : null;
	}

	public getGroupsPermission(permission: string): { [id: number]: AuthLevel } {
		let per = this.getPermission(permission);
		return per ? per.groups : null;
	}

	public getPermissionsList() : Array<string> {
		return Object.keys(this.permissionsData)
			.sort((l1, l2) => (l1.toLowerCase() > l2.toLowerCase()) ? 1 : -1);
	}
}
